define(['angular', 'jquery', 'jquery-caret-plugin'], function (angular) {
    'use strict';

    return angular
        .module('formDirectives', [])
        .directive('insertValue', [
            /**
             * Insert the value into the current input element when clicked.  To include the
             * selected text itself, include the special token "[originalText:default value]".
             * For example: <a href='/'>[originalText:CLICK HERE]</a>
             */
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        $(element).on('mousedown', function (e) {
                            e.preventDefault();

                            var sel, range;
                            sel = window.getSelection();

                            var originalText = sel.toString();

                            var newText = attrs.insertValue;
                            if (originalText != '') {
                                newText = newText.replace(
                                    /\[originalText:[^\]]+\]/,
                                    originalText
                                );
                            } else {
                                newText = newText.replace(
                                    /\[originalText:([^\]]+)\]/,
                                    '$1'
                                );
                            }

                            if (
                                $(sel.anchorNode).parents('.ta-editor')
                                    .length != 0
                            ) {
                                if (sel.getRangeAt && sel.rangeCount) {
                                    range = sel.getRangeAt(0);
                                    range.deleteContents();

                                    var el = document.createElement('span');
                                    el.innerHTML = newText;
                                    var frag = document.createDocumentFragment(),
                                        node,
                                        lastNode;
                                    while ((node = el.firstChild)) {
                                        lastNode = frag.appendChild(node);
                                    }
                                    range.insertNode(frag);

                                    // Preserve the selection
                                    if (lastNode) {
                                        range = range.cloneRange();
                                        range.setStartAfter(lastNode);
                                        range.collapse(true);
                                        sel.removeAllRanges();
                                        sel.addRange(range);
                                    }
                                }
                                scope.$applyAsync();
                            } else {
                                $(':focus')
                                    .range(newText) // comes from jquery-caret
                                    .change(); // trigger change so angular models register the update
                            }
                        });
                    },
                };
            },
        ])

        .directive('fullHeight', [
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        var selector = attrs.fullHeight;
                        if (!selector) {
                            selector = '#content';
                        }
                        if (selector == '.property-info') {
                            scope.$watch(
                                function () {
                                    return $(window).height();
                                },
                                function (height) {
                                    if ($('#header').length > 0) {
                                        height =
                                            height - $('#header').outerHeight();
                                    }
                                    if ($('#footer').length > 0) {
                                        height =
                                            height -
                                            ($('#footer').outerHeight() + 30);
                                    }
                                    if (
                                        $('iframe[src="about:blank"]').length >
                                        0
                                    ) {
                                        height =
                                            height -
                                            $(
                                                'iframe[src="about:blank"]'
                                            ).outerHeight();
                                    }
                                    height = height - 10;
                                    if (
                                        height <
                                        $(
                                            'form[name="detailsForm"]'
                                        ).outerHeight() +
                                            88
                                    ) {
                                        height =
                                            $(
                                                'form[name="detailsForm"]'
                                            ).outerHeight() + 88;
                                    }

                                    if (height > 0 && window.innerWidth > 642) {
                                        $(elem).height(height + 'px');
                                    }
                                }
                            );
                        } else {
                            scope.$watch(
                                function () {
                                    return $(selector).outerHeight();
                                },
                                function (height) {
                                    if (height > 0 && window.innerWidth > 642) {
                                        $(elem).height(height + 'px');
                                    }
                                }
                            );
                        }
                    },
                };
            },
        ])

        .directive('autofocus', [
            '$timeout',
            function ($timeout) {
                return {
                    restrict: 'A',
                    link: function ($scope, $element) {
                        $timeout(function () {
                            $element[0].focus();
                        });
                    },
                };
            },
        ])

        .directive('standardSubmit', [
            function () {
                return {
                    restrict: 'A',
                    scope: {
                        form: '=standardSubmit',
                    },
                    link: function (scope, element, attrs) {
                        element.data('valid', false);
                        element.on('submit', function (e) {
                            scope.$evalAsync(function () {
                                scope.form.$submitted = true;
                            });

                            if (!scope.form.$valid) {
                                e.preventDefault();
                            }
                        });
                    },
                };
            },
        ])
        .directive('initModel', [
            '$compile',
            function ($compile) {
                return {
                    restrict: 'A',
                    priority: 1000,
                    terminal: true,
                    link: function (scope, element, attrs) {
                        element.attr('ng-model', attrs.initModel);
                        element.removeAttr('init-model');
                        $compile(element)(scope);
                        if (!scope[attrs.initModel]) {
                            scope[attrs.initModel] = element[0].value;
                        }
                    },
                };
            },
        ]);
});
